import api from "api";

const orderStations = {
    list:   (slug)       => api().get(`/establishments/${slug}/order-stations`),
    create: (slug, name) => api().post(`/establishments/${slug}/order-stations`, { name }),
    delete: (slug, id)   => api().delete(`/establishments/${slug}/order-stations/${id}`),
};

export default orderStations;
